import React from "react";
import { DropdownChangeParams } from "primereact/dropdown";
import { orderService } from "../../../../../domain";
import { DeliveryPartnerDto } from "../../../../../domain/dtos/delivery-partner";
import { TawreedControlRenderModeWithoutNested, TawreedControlRules, TawreedDropdown } from "../../../../../../../../common";
import { AuthUtils } from "../../../../../../../auth/domain";

export type DeliveryAutoCompleteComponentProps = {
    //
    active?: boolean;
    salesOrderId: number;

    // dropdown
    dropdownName: string;
    dropdownValue?: any;
    dropdownRender: TawreedControlRenderModeWithoutNested;
    dropdownDisabled?: boolean;
    dropdownRules?: TawreedControlRules;
    dropdownOptionLabel?: string;
    dropdownOptionValue?: string;
    dropdownOnChange?(e: DropdownChangeParams): void;
    dropDownPreSelected(e: number): void;
};

export const DeliveryDropdownComponent: React.FC<DeliveryAutoCompleteComponentProps> = (props) => {

    // di
    //const context = React.useContext(GlobalContext);

    // state
    const [loading, setLoading] = React.useState<boolean>(false);
    const [result, setResult] = React.useState<DeliveryPartnerDto[]>([]);

    // React.useEffect(
    //     () => {
    //         console.log(props.dropdownValue);
    //         if(result?.length==0){
    //             setLoading(true);
    //             orderService
    //                 .getDeliveryPartners(props.salesOrderId)
    //                 .then(res => {
    //                     if (res) {
    //                         setResult(res);
    //                     }
    //                 })
    //                 .finally(() => {
    //                     setLoading(false);
    //                 });
    //         };
    //     },
    //     // eslint-disable-next-line react-hooks/exhaustive-deps
    //     [props.dropdownValue]);

    const itemTemplate = (rowData: DeliveryPartnerDto) => {
        return (
            <div className="">
            <div className="flex">
                <span className="mr-auto">{AuthUtils.current().language ==="en" ? rowData.titleEn : rowData.titleAr}</span>
                
            </div>
        </div>
        );
    }

    const change = () =>{
        console.log("ds");
        if(result?.length===0){
            setLoading(true);
            console.log("ds");
            orderService
                .getDeliveryPartners(props.salesOrderId)
                .then(res => {
                    if (res) {
                        setResult(res);
                    }
                })
                .finally(() => {
                    setLoading(false);
                });
        };
    }

    return (
        <TawreedDropdown name={props.dropdownName}
            render={props.dropdownRender}
            disabled={props.dropdownDisabled}
            rules={props.dropdownRules}
            optionLabel={props.dropdownOptionLabel}
            optionValue={props.dropdownOptionValue}
            scrollHeight={'25em'}
            onChange={props.dropdownOnChange}
            onFocus={()=> change()}
            value={props.dropdownValue}
            options={result ? result : []}
            itemTemplate={itemTemplate}
             />
    );
}
